import * as THREE from 'three';
import globalData from "@/utils/globalData.js";
import {
	Line2
} from 'three/examples/jsm/lines/Line2.js';
import {
	LineGeometry
} from 'three/examples/jsm/lines/LineGeometry.js';
import {
	TWEEN
} from 'three/examples/jsm/libs/tween.module.min.js';
import {
	LineMaterial
} from 'three/examples/jsm/lines/LineMaterialSize.js';

const DEGREE_TO_RADIAN = Math.PI / 180;
const clamp = (num, min, max) => (num <= min ? min : num >= max ? max : num);
let materialLine = []
let hexagonList = []
let barList = []
let lightMap = new THREE.TextureLoader().load('./lightCircle.png')
const matLine = new LineMaterial({
	color: '#ff9500',
	chooseColor: '#ffb700', 
	linewidth: 0.1, // in world units with size attenuation, pixels otherwise
	worldUnits: true,
	uniformsNeedUpdate: true,
});


function Destination(list, group, timer, cityMaps,chinaHieght) {
	let first = cityMaps.get(list[0].name)
	for (let i = 0; i < list.length; i++) {
		if (!cityMaps.has(list[i].name)) {
			continue
		}
		let second = cityMaps.get(list[i].name)
		var start = new THREE.Vector3(first.center[0], -first.center[1], chinaHieght+0.01);
		var end = new THREE.Vector3(second.center[0], -second.center[1], chinaHieght+0.01);
		createHexagon(end, group, list[i].name)
		createCone(end, group, second.value, list[i].name)
		if (i === 0) continue
		const CURVE_MIN_ALTITUDE = 20;
		const CURVE_MAX_ALTITUDE = 100;
		const altitude = clamp(
			start.distanceTo(end) * 0.45,
			CURVE_MIN_ALTITUDE,
			CURVE_MAX_ALTITUDE
		);

		const midCoord1 = start.clone().lerp(end, 0.25)
		const midCoord2 = start.clone().lerp(end, 0.75)

		const mid1 = new THREE.Vector3(midCoord1.x, midCoord1.y,chinaHieght+8.01);

		const mid2 = new THREE.Vector3(midCoord2.x, midCoord2.y,chinaHieght+8.01);
		var curve = new THREE.CubicBezierCurve3(start, mid1, mid2, end);
		var points = curve.getPoints(50);
		var vertices = [],
			colors = [];
		points.forEach(function(item, index) {
			vertices.push(item.x, item.y, item.z);
			colors.push(index, 0, 0)
		});
		var geometry = new THREE.BufferGeometry();
		geometry.attributes.position = new THREE.Float32BufferAttribute(vertices, 3)
		const lineGeometry = new LineGeometry();
		lineGeometry.setPositions(vertices);
		lineGeometry.setColors(colors);
		let lines = new Line2(lineGeometry, matLine);
		group.add(lines)
	}
	animates()
} //end Destination()
function animates() {
	requestAnimationFrame(animates);
	matLine.chooseTime += 1
	if (matLine.chooseTime > 150) matLine.chooseTime = 0
	for (let i = 0; i < hexagonList.length; i++) {
		materialLine[i] && (materialLine[i].uniforms.time.value += 0.02)
		hexagonList[i].scale.x += 0.02
		hexagonList[i].scale.y += 0.02
		hexagonList[i].material.opacity -= 0.01
		if (hexagonList[i].material.opacity <= 0) {
			hexagonList[i].scale.x = 1
			hexagonList[i].scale.y = 1
			hexagonList[i].material.opacity = 1
		}
	}
}
function uploadModel() {
	if (barList.length == 0) return
	for (let i = 0; i < barList.length; i++) {
		barList[i].scale.z = 0.5
	}
	barList[globalData.chooseIndex].scale.z = 4
}

function createLineMaterial(myPos, targetPos, timer) {
	var uniforms = {
		targetPos: {
			value: targetPos
		},
		vLength: {
			value: myPos.distanceTo(targetPos)
		},
		time: {
			value: timer
		},
		color: {
			value: new THREE.Color('#e7c500')
		},
	};
	var material = new THREE.ShaderMaterial({
		uniforms: uniforms,
		vertexShader: `
					    varying vec3 vPosition;
					    void main() {
					        vPosition = position;
					        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
					    }`,
		fragmentShader: `
						uniform vec3 targetPos; // 目标位置
					    uniform float vLength;  // 距离
					    uniform float time;
						uniform vec3 color;
					    varying vec3 vPosition;
					    void main() {
							float dist = distance(vPosition, targetPos);
							float a = sin( dist/5.0 - time ) + 1.0;
							if(a<0.3) a = 0.3;
					        gl_FragColor = vec4(color,a);
					    }`,
		transparent: true,
		vertexColors: 0xf0ff00,
		lights: false
	});
	return material;
}

function createHexagon(position, group, name) {
	const geometrys = new THREE.CircleGeometry(0.7, 30);
	const materials = new THREE.MeshBasicMaterial({
		color: 0xffff00
	});
	const circle = new THREE.Mesh(geometrys, materials);
	circle.name = name
	circle.position.copy(position)
	const geometry = new THREE.PlaneGeometry(1.5, 1.5);
	const material = new THREE.MeshBasicMaterial({
		map: lightMap,
		transparent: true,
		depthWrite:false,
		opacity: 1.0
	});
	const plane = new THREE.Mesh(geometry, material);
	plane.position.copy(position)
	plane.name = name
	group.add(plane, circle)
	hexagonList.push(plane)
}

function createCone(position, group, heights = 50, name) {
	let texture = new THREE.TextureLoader().load('./lightbar.png'),
		material = new THREE.MeshBasicMaterial({
			map: texture,
			transparent: true,
			side: THREE.DoubleSide,
			blending: THREE.AdditiveBlending,depthWrite:false
		}),
		height = heights,
		geometry = new THREE.PlaneGeometry(2, height),
		matrix = new THREE.Matrix4(),
		plane1 = new THREE.Mesh(geometry, material)
	matrix.makeRotationX(Math.PI / 2)
	matrix.setPosition(new THREE.Vector3(0, 0, height / -2))
	geometry.applyMatrix4(matrix)
	let plane2 = plane1.clone()
	plane2.rotation.z = Math.PI / 2
	plane1.add(plane2)
	plane1.position.copy(position)
	plane1.rotateX(-Math.PI)
	group.add(plane1)
	if (barList.length == 0) {
		plane1.scale.z = 4
	} else {
		plane1.scale.z = 0.5
	}
	plane1.name = name
	barList.push(plane1)
}
export default {
	Destination,
	uploadModel
}